var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("TableAvatar", {
        staticClass: "multiselect_avatar mr-1",
        attrs: {
          avatarClasses: "w-6 h-6",
          image: _vm.avatar,
          initial: _vm.initials,
          title: _vm.option.name,
          primary: "",
          highlightAvatar: "",
        },
        scopedSlots: _vm._u(
          [
            {
              key: "image",
              fn: function ({ image, defaultClasses }) {
                return [
                  _vm._t("image", null, {
                    image: image,
                    defaultClasses: defaultClasses,
                  }),
                ]
              },
            },
            {
              key: "initial",
              fn: function ({ defaultClasses }) {
                return [
                  _vm._t("initial", null, {
                    defaultClasses: defaultClasses,
                    initial: _vm.initials,
                  }),
                ]
              },
            },
          ],
          null,
          true
        ),
      }),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }